<div class="crm-user-permissions-add-dialog" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" fxLayoutGap="15px">
    <mat-card>
      <div fxLayout="row">
        <h3>Dodaj</h3>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div [fxFlex]="'100'" fxLayoutGap="15px">
          <mat-radio-group aria-label="Select an option" [formControl]="partnerOfwcaControl" fxLayoutGap="45px">
            <mat-radio-button [value]="false" > Partner </mat-radio-button>
            <mat-radio-button [value]="true" > OFWCA </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnerOfwcaControl.value">
        <div [fxFlex]="'100'">
          <app-dict-ofwcas  fxFlex [multiple]="false" label="OFWCA" [control]="ofwcaControl" ></app-dict-ofwcas>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="!partnerOfwcaControl.value">
        <div [fxFlex]="'100'">
          <app-dict-partners fxFlex [multiple]="false" label="Partner" [control]="partnerControl" ></app-dict-partners>
        </div>
      </div>


    </mat-card>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [disabled]="!crmUserPermissionsForm.valid "
            mat-stroked-button color="primary"><mat-icon>add</mat-icon> <span> Zapisz</span></button>

    <button (click)="closeDialog()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

